<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M9.68834 0C4.34633 0 0 4.25578 0 9.4865C0 14.7175 4.34633 18.973 9.68834 18.973C15.0306 18.973 19.3767 14.7175 19.3767 9.4865C19.3767 4.25578 15.0306 0 9.68834 0ZM9.68834 17.2217C5.33246 17.2217 1.78862 13.7517 1.78862 9.48654C1.78862 5.22141 5.33246 1.75135 9.68834 1.75135C14.0442 1.75135 17.5881 5.22137 17.5881 9.4865C17.5881 13.7516 14.0442 17.2217 9.68834 17.2217Z" class="icon-fill"/>
      <path d="M21.738 20.0468L16.6106 15.0262C16.2612 14.6841 15.6954 14.6841 15.346 15.0262C14.9966 15.368 14.9966 15.9226 15.346 16.2645L20.4734 21.285C20.6481 21.456 20.8768 21.5416 21.1057 21.5416C21.3343 21.5416 21.5633 21.456 21.738 21.285C22.0874 20.9432 22.0874 20.3886 21.738 20.0468Z" class="icon-fill"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="22" height="21.5417" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'search'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>